@if (planFeatureService.canAccess(FEATURES.ADVANCED_STATS)) {
  <div class="stats-view p-4 md:p-6 min-h-screen bg-gray-50 dark:bg-slate-900">
    <!-- Recommandations & Insights en haut -->
    <app-insights-card class="block mb-6"></app-insights-card>

    <!-- Performance Overview - KPIs principaux -->
    <app-performance-overview class="block mb-6"></app-performance-overview>

    <!-- Grille avec Top Produits et Catégories -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      <app-top-products-card class="block"></app-top-products-card>
      <app-category-breakdown class="block"></app-category-breakdown>
    </div>

    <!-- Graphique d'activité horaire -->
    <app-hourly-chart class="block mb-6"></app-hourly-chart>
  </div>
} @else {
  <!-- Fonctionnalité verrouillée -->
  <div class="min-h-screen bg-gray-50 dark:bg-slate-900 flex items-center justify-center p-8">
    <div
      class="bg-white dark:bg-slate-800 rounded-2xl shadow-sm dark:shadow-slate-900/30 border border-gray-200 dark:border-slate-700 p-10 max-w-md w-full text-center"
    >
      <div class="text-5xl mb-4">🔒</div>
      <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Statistiques avancées
      </h2>
      <p class="text-gray-500 dark:text-gray-400 mb-2">
        Cette fonctionnalité est disponible à partir du plan
        <span class="font-bold text-purple-600">Pro</span>.
      </p>
      <p class="text-sm text-gray-400 mb-6">
        Accédez à vos performances détaillées, top produits, répartition par
        catégorie et graphiques d'activité horaire.
      </p>
      <a
        routerLink="/subscription"
        class="inline-flex items-center gap-2 bg-purple-600 text-white font-bold px-6 py-3 rounded-xl hover:bg-purple-700 transition"
      >
        ⬆️ Passer au plan Pro
      </a>
      <a
        routerLink="/dashboard"
        class="block mt-4 text-sm text-gray-400 hover:text-gray-600 dark:text-gray-400 transition"
      >
        ← Retour au dashboard
      </a>
    </div>
  </div>
}
